import { sortArrayByProperty } from '@vista/omnichannel-components-domain';
import { WebPaymentMethodType } from '@vista-digital/ocapi-types/v1';
export const getSortedPaymentMethods = (methods) => {
    if (methods === undefined)
        return [];
    return sortArrayByProperty(methods, 'displayPriority');
};
export const getRedirectPaymentMethods = (methods) => {
    return methods.filter(wpm => wpm.type === WebPaymentMethodType.Redirect);
};
export const getEmbeddedPaymentMethods = (methods) => {
    return methods.filter(wpm => wpm.type === WebPaymentMethodType.Embedded);
};
